import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function goToHeroOrderForm(): void {
  try {
    const isHome = typeof window !== 'undefined' && (window.location.pathname === '/' || window.location.pathname.endsWith('/index.html'))
    if (isHome) {
      const element = document.getElementById('hero-order-form')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
        return
      }
    }
    if (typeof window !== 'undefined') {
      window.location.href = '/#hero-order-form'
    }
  } catch {
    // no-op
  }
}
